import { CreateDependentForm } from '@/app/(main)/(pages)/(auth)/dependentes/_components/dependent-form.component';
import { restApiClient } from '@/datasources';
import { Contact, Dependent, DocumentType } from '@/types/auth-base.types';

type CreateDependentRequestDTO = CreateDependentForm & {
  contact: Contact;
  documentType: DocumentType;
};

export async function createDependent(formData: Partial<CreateDependentRequestDTO>) {
  const { data: createDependentResponse } = await restApiClient.post<Dependent>(
    '/online/customers/dependents',
    formData,
  );
  return createDependentResponse;
}
